const VERSION = '2.0.7a'
export default VERSION
